import bug from '../../sourceImg/bug.png';
import dark from '../../sourceImg/dark.png';
import dragon from '../../sourceImg/dragon.png';
import electric from '../../sourceImg/electric.png';
import fairy from '../../sourceImg/fairy.png';
import fighting from '../../sourceImg/fighting.png';
import fire from '../../sourceImg/fire.png';
import flying from '../../sourceImg/flying.png';
import ghost from '../../sourceImg/ghost.png';
import grass from '../../sourceImg/grass.png';
import ground from '../../sourceImg/ground.png';
import ice from '../../sourceImg/ice.png';
import normal from '../../sourceImg/normal.png';
import poison from '../../sourceImg/poison.png';
import psychic from '../../sourceImg/psychic.png';
import rock from '../../sourceImg/rock.png';
import steel from '../../sourceImg/steel.png';
import water from '../../sourceImg/water.png';
import shadow from '../../sourceImg/shadow.png';
import unknow from '../../sourceImg/unknow.png';

export const ArrayImg = [];
ArrayImg.push(
{img: bug, name: "bug"},
{img: dark, name: "dark"},
{img: dragon, name: "dragon"},
{img: electric, name: "electric"},
{img: fairy, name: "fairy"},
{img: fighting, name: "fighting"},
{img: fire, name: "fire"},
{img: flying, name: "flying"},
{img: ghost, name: "ghost"},
{img: grass, name: "grass"},
{img: ground, name: "ground"},
{img: ice, name: "ice"},
{img: normal, name: "normal"},
{img: poison, name: "poison"},
{img: psychic, name: "psychic"},
{img: rock, name: "rock"},
{img: steel, name: "steel"},
{img: water, name: "water"},
{img: shadow, name: "shadow"},
{img: unknow, name: "unknown"}
);